module.exports = __webpack_public_path__ + "img/1552988403.1b12179c.jpg";